/**
 * Trim string
 *
 * @param {string} text
 * @param {number} length
 * @returns { string }
 *
 */

export const trimString = (text, length = 30) => {
  if (!text) return '';
  if (text.length <= length) return text;
  return text.substring(0, length).replace(/.{3}$/g, '...');
};
